import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Form, FormInput, FormSubmitButton, useRouter, FormResetButton, notification } from '@digital/ui';
import { Layout, Card, Input } from 'antd';
import LoginBoxLogo from '../../../public/images/logo_mrn_verde.svg';
import LoginHeaderLogo from '../../../public/images/icone_mrn.png';
import { resetPassword } from '@app/api/account';

const RecuperarSenha = () => {
  const { match } = useRouter();
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState<boolean>();

  const handleSubmit = (values: any) => {
    setIsLoading(true);
    resetPassword(code, values.newPassword, values.username).then(resp => {
      if (resp && resp.valid) {
        window.location.href = '/login';
        notification.success('Senha alterada com sucesso!');
      } else {
        setIsLoading(false);
      }
    });
  };

  const getTokenString = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const accountToken = urlParams.get('Code');
    return accountToken;
  };

  useEffect(() => {
    setCode(getTokenString());
  }, []);

  return (
    <>
      {
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `header.ant-app-header.ant-layout-header {background-color: #161616; display: block !important;} .ant-app-header-actions .ant-btn i.icon {color:#D0D0D0} .ant-app-header-actions .ant-btn i.icon:hover {color:#FFFFFF} .ant-app-header-actions .ant-btn:hover i.icon, .ant-app-header-actions .ant-btn:focus i.icon {padding: 0px; color: #FFFFFF; background-color: transparent; border-color: transparent;} .ant-app-header .ant-app-header-logo span {height: 48px; display: flex; align-items: center} .ant-app-header-logo > .anticon {display:none} .ant-app-header-title:before {content: url(${LoginHeaderLogo}); height: 28px; margin-left: 2px} header.ant-app-header.ant-layout-header{display:none !important}`,
          }}
        />
      }
      <div className="login-view">
        <Layout>
          <div className="image">
            {/* <div className="login-greetings">
              <Title level={2}>SGC - Sistema de Gestão de Contratos</Title>
              <Title level={3}>Entre com suas credenciais para acessar o sistema.</Title>
            </div> */}
          </div>
          <Card>
            <Form
              onSubmit={handleSubmit}
              initialValues={match.params}
              validationSchema={Yup.object().shape({
                username: Yup.string().required('Usuário (Username) deve ser informado'),
                newPassword: Yup.string().required('Nova senha deve ser informada'),
                confirmNewPassword: Yup.string()
                  .required('Confirmação de senha deve ser informada')
                  .oneOf([Yup.ref('newPassword'), null], 'Nova senha e confirmação precisam ser iguais'),
              })}>
              <div className="login-box">
                <div className="login-box-logo">
                  <img src={LoginBoxLogo} />
                </div>
                <div className="login-box-title new-password">Alterar Senha</div>
              </div>
              <FormInput name="username" type="text" label="Usuário (Username)" />
              <FormInput name="newPassword" type="password" label="Nova Senha" />
              <FormInput name="confirmNewPassword" type="password" label="Confirmar Nova Senha" />
              <div className="actions">
                <FormSubmitButton loading={isLoading} title="Salvar" noIcon type="primary" htmlType="submit" />
                <FormResetButton
                  title="Cancelar"
                  type="link"
                  noIcon
                  onClick={() => {
                    window.location.href = '/login';
                  }}
                />
              </div>
            </Form>
          </Card>
        </Layout>
      </div>
    </>
  );
};

export default RecuperarSenha;
